import React from 'react';
import t from 'prop-types';
import BotoneraAreaImagenVisor from './botonera-area-imagen-visor';
import PieBotoneraVisor from './pie-botonera-visor';

var BotoneraAreaImagenVisorDerecha = function BotoneraAreaImagenVisorDerecha(_ref) {
  var versionImagen = _ref.versionImagen,
      onBotonTextoClick = _ref.onBotonTextoClick,
      paso = _ref.paso,
      numPasos = _ref.numPasos,
      onBotonSiguienteClick = _ref.onBotonSiguienteClick,
      onPlay = _ref.onPlay,
      playing = _ref.playing;
  return React.createElement(BotoneraAreaImagenVisor, null, onBotonTextoClick && React.createElement('div', {
    className: 'botonTextoVisorImagenes' + (versionImagen === 'a' ? ' activa' : ''),
    onClick: onBotonTextoClick
  }), onBotonSiguienteClick && React.createElement(PieBotoneraVisor, null, paso >= numPasos && React.createElement('div', {
    className: 'siguienteImagenVisorImagenes desactivado'
  }), paso < numPasos && React.createElement('div', {
    className: 'siguienteImagenVisorImagenes',
    onClick: onBotonSiguienteClick
  })));
};

BotoneraAreaImagenVisorDerecha.propTypes = process.env.NODE_ENV !== "production" ? {
  versionImagen: t.string,
  onBotonTextoClick: t.func,
  paso: t.number,
  numPasos: t.number,
  onBotonSiguienteClick: t.func,
  onPlay: t.func,
  playing: t.bool
} : {};
export default BotoneraAreaImagenVisorDerecha;